/* eslint-disable */
<template>

  <div>

    <proposta-create
      v-if="isAuthorized('PROPOSE_ADD')"
      :proposeDb="propose"
      :proposeConfigDb="propose.config"
      ref="propostaCreate"/>

  </div>

</template>

<script>
  //import axios from 'axios'
  import PropostaCreate from '../../components/propose/PropostaCreate'
  import UserAuthorization from "@/mixins/UserAuthorization";

  export default {
    name: 'Proposta',
    mixins:[UserAuthorization],
    components:{
      PropostaCreate,
    },
    data () {
      return {
        propose: {
          config: [],
          client: {
            name: null,
            cnpj: null,
            sector: {name: null}
          },
          guarantor: {
            name: null,
            cnpj: null,
            sector: {name: null}
          },
          operationType: null,
          comments: null,
          guaranteeType: null,
          guaranteePeriod: null,
          values: []
        },
      }
    },
  }
</script>

<style scoped>

</style>
